import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';
import type { EdgeLinkLogEntry } from '@/hooks/useEdgeLinkLogs';
import LogViewer from '../components/LogViewer';

interface BridgeLogsTabProps {
  logs: EdgeLinkLogEntry[];
  onClear: () => void;
  isConnected: boolean;
  error: string | null;
}

export default function BridgeLogsTab({ logs, onClear, isConnected, error }: BridgeLogsTabProps) {
  return (
    <div className="space-y-4">
      <LogViewer logs={logs} isConnected={isConnected} onClear={onClear} maxHeight="400px" />

      {/* Error alert */}
      {error && (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Connection Error</AlertTitle>
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
    </div>
  );
}
